import {
  defaultColumnVisibilityOptions,
  defaultColumnVisibilityParams,
} from '@contracts/common/params/ColumnVisibilityParams';
import { ColumnVisibilityType } from '@contracts/common/ColumnVisibilityType';
import { ColumnVisibilitySettings } from '@contracts/common/ColumnVisibilitySettings';

export const scheduledSendCreditTasksListColumns = [
  'scheduledSendCreditTask.id',
  'scheduledSendCreditTask.delayMs',
  'scheduledSendCreditTask.createdAt',
  'scheduledSendCreditTask.data.apiUrl',
  'scheduledSendCreditTask.data.transactionId',
  'scheduledSendCreditTask.data.roundId',
  'scheduledSendCreditTask.data.amount',
  'scheduledSendCreditTask.data.language',
  'scheduledSendCreditTask.data.currency',
  'scheduledSendCreditTask.data.reason',
  'scheduledSendCreditTask.data.category',
  'scheduledSendCreditTask.data.providerId',
  'scheduledSendCreditTask.data.gameId',
  'scheduledSendCreditTask.data.operation',
  'scheduledSendCreditTask.data.playerId',
  'scheduledSendCreditTask.data.multiplier',
  'scheduledSendCreditTask.data.betId',
] as const;

export type ScheduledSendCreditTasksListColumns =
  (typeof scheduledSendCreditTasksListColumns)[number];

export type ScheduledSendCreditTasksListFilter = {
  'scheduledSendCreditTask.id': string | undefined;
  'scheduledSendCreditTask.delayMs': number | undefined;
  'scheduledSendCreditTask.createdAt': number | undefined;
  'scheduledSendCreditTask.data.apiUrl': string | undefined;
  'scheduledSendCreditTask.data.transactionId': string | undefined;
  'scheduledSendCreditTask.data.roundId': string | undefined;
  'scheduledSendCreditTask.data.amount': number | undefined;
  'scheduledSendCreditTask.data.language': string | undefined;
  'scheduledSendCreditTask.data.currency': string | undefined;
  'scheduledSendCreditTask.data.reason': string | undefined;
  'scheduledSendCreditTask.data.category': string | undefined;
  'scheduledSendCreditTask.data.providerId': string | undefined;
  'scheduledSendCreditTask.data.gameId': number | undefined;
  'scheduledSendCreditTask.data.operation': string | undefined;
  'scheduledSendCreditTask.data.playerId': string | undefined;
  'scheduledSendCreditTask.data.multiplier': number | undefined;
  'scheduledSendCreditTask.data.betId': string | undefined;
};

export const defaultScheduledSendCreditTasksListFilter: ScheduledSendCreditTasksListFilter = {
  'scheduledSendCreditTask.id': undefined,
  'scheduledSendCreditTask.delayMs': undefined,
  'scheduledSendCreditTask.createdAt': undefined,
  'scheduledSendCreditTask.data.apiUrl': undefined,
  'scheduledSendCreditTask.data.transactionId': undefined,
  'scheduledSendCreditTask.data.roundId': undefined,
  'scheduledSendCreditTask.data.amount': undefined,
  'scheduledSendCreditTask.data.language': undefined,
  'scheduledSendCreditTask.data.currency': undefined,
  'scheduledSendCreditTask.data.reason': undefined,
  'scheduledSendCreditTask.data.category': undefined,
  'scheduledSendCreditTask.data.providerId': undefined,
  'scheduledSendCreditTask.data.gameId': undefined,
  'scheduledSendCreditTask.data.operation': undefined,
  'scheduledSendCreditTask.data.playerId': undefined,
  'scheduledSendCreditTask.data.multiplier': undefined,
  'scheduledSendCreditTask.data.betId': undefined,
};

export const scheduledSendCreditTasksListColumnVisibilitySettings = {
  'scheduledSendCreditTask.id': ColumnVisibilityType.Visible,
  'scheduledSendCreditTask.delayMs': ColumnVisibilityType.CanBeHidden,
  'scheduledSendCreditTask.createdAt': ColumnVisibilityType.CanBeHidden,
  'scheduledSendCreditTask.data.apiUrl': ColumnVisibilityType.CanBeHidden,
  'scheduledSendCreditTask.data.transactionId': ColumnVisibilityType.CanBeHidden,
  'scheduledSendCreditTask.data.roundId': ColumnVisibilityType.CanBeHidden,
  'scheduledSendCreditTask.data.amount': ColumnVisibilityType.CanBeHidden,
  'scheduledSendCreditTask.data.language': ColumnVisibilityType.CanBeHidden,
  'scheduledSendCreditTask.data.currency': ColumnVisibilityType.CanBeHidden,
  'scheduledSendCreditTask.data.reason': ColumnVisibilityType.CanBeHidden,
  'scheduledSendCreditTask.data.category': ColumnVisibilityType.CanBeHidden,
  'scheduledSendCreditTask.data.providerId': ColumnVisibilityType.CanBeHidden,
  'scheduledSendCreditTask.data.gameId': ColumnVisibilityType.CanBeHidden,
  'scheduledSendCreditTask.data.operation': ColumnVisibilityType.CanBeHidden,
  'scheduledSendCreditTask.data.playerId': ColumnVisibilityType.CanBeHidden,
  'scheduledSendCreditTask.data.multiplier': ColumnVisibilityType.CanBeHidden,
  'scheduledSendCreditTask.data.betId': ColumnVisibilityType.CanBeHidden,
} satisfies ColumnVisibilitySettings<ScheduledSendCreditTasksListColumns>;

export const defaultScheduledSendCreditTasksListColumnVisibility = defaultColumnVisibilityParams(
  scheduledSendCreditTasksListColumnVisibilitySettings
);

export const scheduledSendCreditTasksListColumnVisibilityOptions = defaultColumnVisibilityOptions(
  scheduledSendCreditTasksListColumns,
  scheduledSendCreditTasksListColumnVisibilitySettings
);
